module.exports = __webpack_public_path__ + "img/functional2-img2.68fa32f2.png";